import { Injectable, EventEmitter } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import {
  Message,
  RequestUsuariosActivos,
  RequestConexionSignalR,
  RequestChatsHistorico,
  NotifySignalR,
  HubChatHistorico,
  ReconexionChat,
  RequestLlamadas,
  ResponseMessageCall,
} from '../_models';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '.';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  messageReceived = new EventEmitter<Message>();
  usuariosActivos = new EventEmitter<RequestUsuariosActivos[]>();
  connectionEstablished = new EventEmitter<Boolean>();
  idSignalR = new EventEmitter<string>();
  conexion: RequestConexionSignalR;
  idUsuario: string;
  Hora: string;
  ArrayChatsHistorico = new EventEmitter<RequestChatsHistorico[]>();
  ArrayChatsHistoricoHub = new EventEmitter<HubChatHistorico[]>();
  public connectionIsEstablished = false;
  public _hubConnection: signalR.HubConnection;
  MessageHistorico = new EventEmitter<ResponseMessageCall[]>();
  ArrayLlamadasHistorico = new EventEmitter<RequestLlamadas[]>();
  Notificacio = new EventEmitter<NotifySignalR>();
  constructor(public authenticationService: AuthenticationService) {
    if (this.authenticationService.currentUserValue) {
      this.createConnection();
      this.registerOnServerEvents();
      this.startConnection();
      //this.router.navigate(['/']);
    }
  }

  sendMessage(message: Message) {
    this._hubConnection.invoke('NewMessage', message);
  }
  ConexionSignalR(usuario: RequestConexionSignalR) {
    this._hubConnection.invoke('Conexion', usuario);
  }
  ConexionChatHistorico(usuario: RequestConexionSignalR) {
    this._hubConnection.invoke('ViewUsersChatHistorico', usuario);
  }
  ConexionChatUsers(usuario: RequestConexionSignalR) {
    this._hubConnection.invoke('ViewUsersChat', usuario);
  }
  DesConexionSignalR(usuario: RequestConexionSignalR) {
    this._hubConnection.invoke('Desconexion', usuario);
  }
  ReloadChatMessage(message: ReconexionChat) {
    this._hubConnection.invoke('ViewChatForClientId', message);
  }

  public createConnection() {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.apiSignalR}/ChatSignalR`, {
        accessTokenFactory: () => json.token,
      })
      .withAutomaticReconnect([0, 1000, 5000, null])
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }

  public startConnection(): void {
    var json = JSON.parse(localStorage.getItem('SignalR')); //json con datos de usuario
    this._hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        console.log('Hub connection started');
        this.connectionEstablished.emit(true);
        this.conexion = {
          Useremail: json.useremail,
          plataforma: 'App-Werehouse',
          companyId: String(json.company),
        };
        this.ConexionSignalR(this.conexion);
      })
      .catch((err) => {
        console.log('Error while establishing connection, retrying...');
        setTimeout(function () {
          this.startConnection();
        }, 5000);
      });
  }

  public registerOnServerEvents(): void {
    this._hubConnection.on('Conexion', (data: any) => {
      this.idUsuario = String(data);
      this.idSignalR.emit(String(data))
      console.log('Hub connection started', data);
    });
    this._hubConnection.on('Desconexion', (data: any) => {
      this.idUsuario = String(data);
    });
    this._hubConnection.on('NewMessage', (data: any) => {
      this.messageReceived.emit(data);
    });
 
    this._hubConnection.on('ViewUsersChat', (data: any) => {
      this.usuariosActivos.emit(data);
    });
  
    this._hubConnection.on('ViewUsersChatHistorico', (data: any) => {
      this.ArrayChatsHistorico.emit(data);
    });
    this._hubConnection.on('SendNotifityUI', (data: any) => {
      this.Notificacio.emit(data);
    });
    this._hubConnection.on('ViewChatForClientId', (data: any) => {
      this.ArrayChatsHistoricoHub.emit(data);
    });
    this._hubConnection.on('hora', (data: any) => {
      this.Hora = data;
      console.log('Reconexion-signalR-C#', data);
      // this.startConnection();
    });
    this._hubConnection.on('LlamadasHistorico', (data: any) => {
      this.ArrayLlamadasHistorico.emit(data);
    });
    this._hubConnection.on('MessagesHistorico', (data: any) => {
      this.MessageHistorico.emit(data);
    });
  }
}
